import { Component, Input, Output, EventEmitter, forwardRef, ViewChild, OnInit } from '@angular/core';
import moment from 'moment';
import { LibraryService } from '@core/services/library/library.service';
import { FLOW_DATE_FORMAT } from '@core/constants';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IonModal } from '@ionic/angular';
import { DatetimeCustomEvent } from '@ionic/angular';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatepickerComponent),
            multi: true
        }],
    standalone: false
})
export class DatepickerComponent implements ControlValueAccessor, OnInit {
    @Input() max = moment();
    @Input() showInput = true;
    @Input() value: moment.Moment = moment();
    @Input() icon: string = 'calendar'; // <-- NUEVO: Control del icono calcado a Svelte
    @Output() changed = new EventEmitter<moment.Moment>();
    @ViewChild('datepickerModal') datepickerModal: IonModal;

    private localeMapper = (locale) => ({
        es: 'es-ES',
        ca: 'ca-ES',
        en: 'en-US',
        fr: 'fr-FR',
        it: 'it-IT',
        pt: 'pt-PT',
        ru: 'ru-RU'
    })[locale]

    locale = 'es-ES';

    private _disabled: boolean;
    get disabled(): boolean | '' {
        return this._disabled;
    }

    @Input()
    set disabled(disabled: boolean | '') {
        this._disabled = disabled === '' || disabled;
    }

    get formattedValue(): string {
        if (this.value) {
            return moment(this.value, FLOW_DATE_FORMAT).format(FLOW_DATE_FORMAT);
        }

        return '';
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onChange = (_: any): void => { };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onBlur = (_: any): void => { };

    constructor(
        private libraryService: LibraryService
    ) {
    }

    ngOnInit() {
        this.locale = this.localeMapper(this.libraryService.locale) ?? 'es-ES';
    }

    handleChange(event: Event): void {
        const typedEvent = event as DatetimeCustomEvent;
        this.value = moment(typedEvent.detail.value);
        this.onChange(this.value);
        this.changed.emit(this.value);

        this.datepickerModal.dismiss();
    }

    openDatepicker(): void {
        if (this.disabled) {
            return;
        }

        this.datepickerModal.present();
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onBlur = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(value: any): void {
        this.value = value;
    }
}